import { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import { useHistory } from "react-router-dom";
import moment from "moment";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function Ticketsupportlist() {
  const { apiEndpoint } = config;
  const history = useHistory();
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTicketSupportList();
  }, []);

  async function fetchTicketSupportList() {
    setLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/igm/getallSellersupport`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        }
      });
      const details = data?.data || data?.igmDetails || [];
      if (Array.isArray(details)) {
        setListData(details);
      } else if (details && typeof details === "object" && Object.keys(details).length > 0) {
        setListData([details]);
      } else {
        setListData([]);
      }
    } catch (err) {
      console.error("Error fetching ticket support list:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <ThemeMaker>
      <div className="row w-100 m-0 mt-1">
        <div className="col-md-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/ticketsupport")}
                  className="btn btn-primary btn-sm d-flex align-items-center justify-content-center p-2"
                  title="Back"
                >
                  <ArrowBackIcon />
                </span>
                <h6 className="m-0 font-weight-bold text-primary">All Ticket Support List</h6>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: "70vh" }}>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped table-hover align-middle mb-0">
                    <thead className="thead-light" style={{ backgroundColor: "#F8FAFC" }}>
                      <tr>
                        <th style={{ width: "60px" }}>Sr. NO.</th>
                        <th>Support Person Name</th>
                        <th>Seller name </th>
                        <th>Support Email</th>
                        <th>Support Phone</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listData && listData.length > 0 ? (
                        listData.map((item, idx) => (
                          <tr key={item.id || idx}>
                            <td className="font-weight-bold text-secondary">{idx + 1}</td>
                            <td className="font-weight-bold text-dark">
                              {item.support_person_name || item.org_person_name || item.name || "-"}
                            </td>
                            <td>
                              {item.seller_name || "-"}
                            </td>
                            <td>
                              {item.support_email || item.org_email || item.email || "-"}
                            </td>

                            <td>
                              <span className="badge badge-light p-2" style={{ fontSize: "13px", backgroundColor: "#F1F5F9", color: "#334155" }}>
                                {item.support_phone || item.org_phone || item.number || "-"}
                              </span>
                            </td>
                            <td className="text-muted" style={{ fontSize: "13px" }}>
                              {item.created_at ? moment(item.created_at).format("DD MMM YYYY, hh:mm A") : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center py-4 text-muted">
                            No seller support records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ThemeMaker>
  );
}
